export {
  legalEntitiesApi,
  useGetLegalEntitiesForSystemQuery,
  useGetLegalEntitiesQuery,
  useGetLegalEntityByIdQuery,
  useLazyGetLegalEntitiesForSystemQuery,
  useLazyGetLegalEntitiesQuery,
  useLazyGetLegalEntityByIdQuery,
  useUpdateLegalEntityMutation,
} from './api';
export {
  LegalEntitiesEndpoints,
  type GetLegalEntitiesForSystemRequest,
  type GetLegalEntitiesForSystemResponse,
  type GetLegalEntitiesRequest,
  type GetLegalEntitiesResponse,
  type GetLegalEntityByIdRequest,
  type GetLegalEntityByIdResponse,
  type ModelItemEx,
  type ModelLegalEntity,
  type UpdateLegalEntityRequest,
  type UpdateLegalEntityResponse,
} from './types';
